/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_settings_timezone_suggest_description = /** @type {(inputs: { timezone: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`We detected ${i?.timezone}. Set it so your stats show in local time.`)
};

const pl_settings_timezone_suggest_description = /** @type {(inputs: { timezone: NonNullable<unknown> }) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Wykryliśmy ${i?.timezone}. Ustaw ją, aby statystyki pokazywały czas lokalny.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{ timezone: NonNullable<unknown> }} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const settings_timezone_suggest_description = (inputs, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.settings_timezone_suggest_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("settings_timezone_suggest_description", locale)
	if (locale === "en") return en_settings_timezone_suggest_description(inputs)
	return pl_settings_timezone_suggest_description(inputs)
};